/* eslint-disable no-unused-vars */
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
//import './registerServiceWorker'
import './sw-registry'

import emitterApp from './plugins/events/emitter'
import filters from './plugins/filter/filter'
import { emitter } from './plugins/events/emitter'
import httpPlugin from './plugins/http'
import globalComponent from './plugins/globalComponent'

import { IonicVue } from '@ionic/vue'

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css'

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css'
import '@ionic/vue/css/structure.css'
import '@ionic/vue/css/typography.css'

//import '@/theme/scss/style.scss'

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css'
import '@ionic/vue/css/float-elements.css'
import '@ionic/vue/css/text-alignment.css'
import '@ionic/vue/css/text-transformation.css'
import '@ionic/vue/css/flex-utils.css'
import '@ionic/vue/css/display.css'

import http from '@/plugins/http/axios'
import scroll from '@/plugins/scroll'
import lazyLoadImage from '@/plugins/image/vue3-lazy-load'

import { isPlatform } from '@ionic/vue'
import VueGtag from 'vue-gtag-next'

/* Theme variables */
import './theme/variables.css'
import './theme/util.css'

import { addIcons } from 'ionicons'
import * as allIcons from 'ionicons/icons'
import { __ } from '@/plugins/tools/lodash'
import lodash from '@/plugins/tools/lodash'
addIcons(__.mapKeys(allIcons, (value, key) => __.kebabCase(key)))

const app = createApp(App)
  .use(IonicVue)
  .use(router)
  .use(store)
  .use(globalComponent)
  .use(emitterApp)
  .use(filters)
  .use(httpPlugin)
  .use(lazyLoadImage)
  .use(scroll)
  .use(lodash)
  .use(VueGtag, {
    property: [
      {
        id: 'G-91FDT0L5VL'
      },
      {
        id: 'UA-104318056-1'
      }
    ]
  })

function initServer(url) {
  return new Promise((resolve, reject) => {
    /* let callHttp = _.debounce(() => {
      //resolve('ok')
      reject('err')
    }, 1500)
    callHttp() */
    http
      .get(url)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

async function startVue() {
  let isDesktop = isPlatform('desktop')
  if (isDesktop && process.env.NODE_ENV === 'production') {
    await router.isReady().then(() => {
      window.location.replace(
        `https://www.lion.com.co${router.currentRoute.value.path}`
      )
      return false
    })
  }
  await initServer('app-mobile/init-server').then(
    async (res) => {
      window.serverData = res.data
      store.state.app.config = res.data
      store.state.app.name = res.data.appName
      await router.isReady().then(() => {
        app.mount('#app')
      })
    },
    async (err) => {
      await router.isReady().then(() => {
        app.mount('#app')
        emitter.emit('message', {
          message: 'No pudimos conectarnos con el servidor',
          color: 'danger'
        })
      })
    }
  )
}

startVue()
